import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Form, Input, Button, Checkbox, useDispatch, useSelector
} from './AntComponent';
import GarudaLogo from '../assets/images/newlogo.svg';
import LoginImg from '../assets/images/login-image.png';
import { userLogin } from "../store/actions/authenticationService";
import KosoftLogo from '../assets/images/kosoft-logo.svg';


export default function Login() {
    const { success, loginInfo, loading } = useSelector((state) => state.auth);
    const [form] = Form.useForm();
    const isAuth = localStorage.getItem("authentication");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = (val) => {
        let inputJson = {
            "EmailAddress": val.email,
            "Password": val.password
        }
        dispatch(userLogin(inputJson));
    }

    useEffect(() => {
        if (loginInfo?.statusCode == 200) {
            navigate('/dashboard');
        }
    }, [loginInfo?.message]);

    return (
        <div className="login-bg container-fluid">
            <div className="bg-clr">
                <div className="container row mx-auto">
                    <div className="col-md-6 my-auto">
                        <div className=" bg-white rounded p-3 shadow-lg my-auto">
                            <div className="text-center mx-auto mb-4 pt-3">
                                <img src={GarudaLogo} alt="login logo" width={300} height={110} />
                            </div>
                            <Form
                                form={form}
                                layout="vertical"
                                name="basic"
                                className="px-5 pb-5 pt-3"
                                initialValues={{
                                    remember: true,
                                }}
                                autoComplete="off"
                                onFinish={handleLogin}
                            >
                                <Form.Item label="Email" name="email" rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    }, {
                                        type: 'email',
                                        message: "Enter valid email address"

                                    },
                                ]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item label="Password" name="password" className="mb-2"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'This field is required!',
                                        },
                                    ]}>
                                    <Input.Password />
                                </Form.Item>
                                <div className="row m-0">
                                    <Form.Item className="ps-0 col-auto">
                                        <Checkbox className="me-2 col-auto">Remember Password</Checkbox>
                                    </Form.Item>
                                    <Form.Item className="ps-0 ms-auto col-auto pe-0">
                                        <span>Forgot Password?</span>
                                    </Form.Item>
                                </div>
                                <Button block className="btn btn-save text-white my-4" size="large" htmlType="submit" loading={loading}>
                                    Login
                                </Button>
                            </Form>


                        </div>
                        <div className="row m-0 mt-5 pt-5">
                            <div className="col-auto">
                                <small>powered by <img className="ps-2"src={KosoftLogo} alt="logo" width={60} height={50} /></small>
                            </div>
                            <div className="col-auto ms-auto">
                                <small>Terms & Conditions Apply</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 me-auto mt-auto">
                        <img src={LoginImg} alt="right side " heigth={400} width={800} />
                    </div>
                </div>
            </div>
        </div>
    )
}